import React, { useState } from "react";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/atoms/button";

export default function LogoutButton() {
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogout = async () => {
    await auth.signOut();
    setMessage("Logged out!");
    setTimeout(() => {
      setMessage("");
      navigate("/welcome");
    }, 1000);
  };

  return (
    <>
      <Button
        onClick={handleLogout}
        className="bg-gray-200 text-black px-4 py-2 rounded hover:bg-gray-300"
        type="secondary"
      >
        Log out
      </Button>
      {message && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow">
          {message}
        </div>
      )}
    </>
  );
}
